import React from "react";

import {useReduxData} from "../../../../customHooks/useContextReduxData";
import {useCopyPaste} from "../../../../customHooks/useContextCopyPaste";
import {useLocalization} from "../../../../../customHooks/useContextLocalization";
import tooltipHOC from "../../../../../components/tooltipHOC";
import hintModeTooltipHOC from "../../../../onboarding/hintModeTooltipHOC";

import {ReactComponent as Paste} from "../images/first-block/paste.svg";


const IconPaste = tooltipHOC(
    hintModeTooltipHOC(Paste, "firstToolBlockPaste", {marginBottom: "-2px", marginTop: "-2px"}),
    {display: "flex"},
    {direction: "right", padding: "10px"}
);


export default function () {
    const locale = useLocalization();
    const {pasteObjects} = useCopyPaste();
    const {clipboard, isWatchMode} = useReduxData();

    const paste = () => pasteObjects({x: 0, y: 0});

    return <div className="tool-block-item" onClick={paste}>
        <IconPaste
            className={!isWatchMode && clipboard.length !== 0 ? "" : "disabled"}
            tooltipContent={locale.get.studio.header.firstToolBlock.paste}
        />
    </div>;
}